import _Object$keys from 'babel-runtime/core-js/object/keys';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import ConsentManagerBuilder from '../consent-manager-builder';
import Container from './container';
import { ADVERTISING_CATEGORIES, FUNCTIONAL_CATEGORIES } from './categories';
var initialPreferences = {
  marketingAndAnalytics: null,
  advertising: null,
  functional: null
};

var ConsentManager = function (_PureComponent) {
  _inherits(ConsentManager, _PureComponent);

  function ConsentManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConsentManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConsentManager.__proto__ || _Object$getPrototypeOf(ConsentManager)).call.apply(_ref, [this].concat(args))), _this), _this.handleMapCustomPreferences = function (_ref2) {
      var destinations = _ref2.destinations,
          preferences = _ref2.preferences;
      var destinationPreferences = {};
      var customPreferences = {}; // Default unset preferences to true (for implicit consent)

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(_Object$keys(preferences)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var preferenceName = _step.value;
          var value = preferences[preferenceName];

          if (typeof value === 'boolean') {
            customPreferences[preferenceName] = value;
          } else {
            customPreferences[preferenceName] = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _loop = function _loop(destination) {
        if (ADVERTISING_CATEGORIES.find(function (c) {
          return c === destination.category;
        })) {
          destinationPreferences[destination.id] = customPreferences.advertising;
        } else if (FUNCTIONAL_CATEGORIES.find(function (c) {
          return c === destination.category;
        })) {
          destinationPreferences[destination.id] = customPreferences.functional;
        } else {
          // Fallback to marketing
          destinationPreferences[destination.id] = customPreferences.marketingAndAnalytics;
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(destinations), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var destination = _step2.value;

          _loop(destination);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return {
        destinationPreferences: destinationPreferences,
        customPreferences: customPreferences
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConsentManager, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          writeKey = _props.writeKey,
          otherWriteKeys = _props.otherWriteKeys,
          shouldRequireConsent = _props.shouldRequireConsent,
          implyConsentOnInteraction = _props.implyConsentOnInteraction,
          cookieDomain = _props.cookieDomain,
          bannerContent = _props.bannerContent,
          bannerSubContent = _props.bannerSubContent,
          bannerTextColor = _props.bannerTextColor,
          bannerBackgroundColor = _props.bannerBackgroundColor,
          preferencesDialogTitle = _props.preferencesDialogTitle,
          preferencesDialogContent = _props.preferencesDialogContent,
          cancelDialogTitle = _props.cancelDialogTitle,
          cancelDialogContent = _props.cancelDialogContent,
          onError = _props.onError;
      return React.createElement(ConsentManagerBuilder, {
        onError: onError,
        writeKey: writeKey,
        otherWriteKeys: otherWriteKeys,
        shouldRequireConsent: shouldRequireConsent,
        cookieDomain: cookieDomain,
        initialPreferences: initialPreferences,
        mapCustomPreferences: this.handleMapCustomPreferences
      }, function (_ref3) {
        var destinations = _ref3.destinations,
            newDestinations = _ref3.newDestinations,
            preferences = _ref3.preferences,
            isConsentRequired = _ref3.isConsentRequired,
            setPreferences = _ref3.setPreferences,
            resetPreferences = _ref3.resetPreferences,
            saveConsent = _ref3.saveConsent;
        return React.createElement(Container, {
          destinations: destinations,
          newDestinations: newDestinations,
          preferences: preferences,
          isConsentRequired: isConsentRequired,
          setPreferences: setPreferences,
          resetPreferences: resetPreferences,
          saveConsent: saveConsent,
          implyConsentOnInteraction: implyConsentOnInteraction,
          bannerContent: bannerContent,
          bannerSubContent: bannerSubContent,
          bannerTextColor: bannerTextColor,
          bannerBackgroundColor: bannerBackgroundColor,
          preferencesDialogTitle: preferencesDialogTitle,
          preferencesDialogContent: preferencesDialogContent,
          cancelDialogTitle: cancelDialogTitle,
          cancelDialogContent: cancelDialogContent
        });
      });
    }
  }]);

  return ConsentManager;
}(PureComponent);

ConsentManager.displayName = 'ConsentManager';
ConsentManager.defaultProps = {
  otherWriteKeys: [],
  shouldRequireConsent: function shouldRequireConsent() {
    return true;
  },
  implyConsentOnInteraction: true,
  onError: undefined,
  cookieDomain: undefined,
  bannerTextColor: '#fff',
  bannerSubContent: 'You can change your preferences at any time.',
  bannerBackgroundColor: '#1f4160',
  preferencesDialogTitle: 'Website Data Collection Preferences',
  cancelDialogTitle: 'Are you sure you want to cancel?'
};
export default ConsentManager;